module.exports = __webpack_public_path__ + "img/218.21d4d279.png";